import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable({
    providedIn: 'root'
})
export class ClaimOverviewService {
    public url: string;

    constructor(private _http: HttpClient) {
        this.url = Global.url;
    }

    // Obtener siniestro por ID con información completa
    getClaimById(id: number): Observable<any> {
        return this._http.get(`${this.url}V1/claims/${id}`);
    }

    // Actualizar siniestro
    updateClaim(claim: any): Observable<any> {
        return this._http.put(`${this.url}V1/claims/${claim.id}`, claim);
    }

    // Actualizar solo el estado del siniestro
    updateClaimStatus(id: number, status: string): Observable<any> {
        return this._http.put(`${this.url}V1/claims/${id}/status`, { status });
    }
}
